import { AppContext } from 'contexts/AppContext';
// import { useLoading } from 'contexts/LoadingContext';
import { useState, useEffect, useContext } from 'react';
import { postRequest, patchRequest, deleteRequest, getRequest } from 'services/api';

// Hook untuk Fetch data (GET)
// export const useFetchData = (url, reload, loadingType = 'full') => {
//     const [data, setData] = useState([]);
//     const [error, setError] = useState(null);
//     const { startLoading, stopLoading } = useLoading(); // Menggunakan context

//     useEffect(() => {
//         const fetchData = async () => {
//             startLoading(loadingType); // Mulai loading
//             try {
//                 const result = await getRequest(url);
//                 setData(result);  // Sesuaikan dengan struktur data yang dikembalikan API
//             } catch (error) {
//                 setError(error.message);
//             } finally {
//                 stopLoading(); // Stop loading setelah fetch selesai
//             }
//         };

//         fetchData();
//     }, [url, reload, startLoading, stopLoading]); // Menggunakan JSON.stringify agar tidak terjadi infinite loop

//     return { data, error, loading: useLoading().isLoading };
// };

export const useFetchData = (url, stateType) => {
    const [localError, setLocalError] = useState(null); // Untuk handle error di local state
    const { dispatch } = useContext(AppContext); // Dapatkan dispatch dari context global

    const fetchData = async () => {
        dispatch({ type: 'LOADING', stateType });  // Mulai loading untuk stateType yang sesuai
        try {
            const result = await getRequest(url); // Panggil API
            dispatch({ type: 'FETCH_SUCCESS', stateType, payload: result }); // Dispatch data sukses
        } catch (error) {
            setLocalError(error.message); // Set error ke state local
            dispatch({ type: 'ERROR', stateType, payload: error.message }); // Dispatch error ke context
        }
    };

    useEffect(() => {
        fetchData();
    }, [url, dispatch, stateType]);

    return { error: localError, refetch: fetchData }; // Kembalikan error jika ada
};



// Hook untuk Create (POST)
// export const useCreateData = (url) => {
//     const [loading, setLoading] = useState(false);

//     const createData = async (data) => {
//         setLoading(true);
//         try {
//             const result = await postRequest(url, data);
//             return { success: true, data: result };
//         } catch (err) {
//             const errorResponse = {
//                 code: err.code || null,
//                 message: err.errors || 'An error occurred',
//             };
//             return { success: false, errorResponse };
//         } finally {
//             setLoading(false);
//         }
//     };

//     return { createData, loading };
// };

export const useCreateData = (url, stateType) => {
    const { dispatch } = useContext(AppContext);
    const createData = async (data) => {
        dispatch({ type: 'LOADING', stateType });
        try {
            const result = await postRequest(url, data);
            dispatch({ type: 'ADD_DATA', stateType, payload: result });
            return { success: true, data: result };
        } catch (err) {
            const errorResponse = {
                code: err.code || null,
                message: err.errors || 'An error occurred',
            };
            dispatch({ type: 'ERROR', stateType, payload: errorResponse });
            return { success: false, errorResponse };
        }
    };

    return { createData };
};

// Hook untuk Update (PATCH)
export const useUpdateData = (url, stateType) => {
    const { dispatch } = useContext(AppContext);

    const updateData = async (data) => {
        dispatch({ type: 'LOADING', stateType });
        try {
            const result = await patchRequest(url, data);
            dispatch({ type: 'UPDATE_DATA', stateType, payload: result });
            console.log('result', result);
            return { success: true, data: result };
        } catch (err) {
            const errorResponse = {
                code: err.code || null,
                message: err.errors || 'An error occurred',
            };
            dispatch({ type: 'ERROR', stateType });
            return { success: false, errorResponse };
        }
    };

    return { updateData };
};

// Hook untuk Delete (DELETE)
// export const useDeleteData = (url) => {
//     const { startLoading, stopLoading } = useLoading(); // Menggunakan context

//     const deleteData = async (id) => {
//         startLoading('full'); // Mulai loading
//         try {
//             const result = await deleteRequest(`${url}/${id}`);
//             return { success: true, data: result };
//         } catch (err) {
//             const errorResponse = {
//                 code: err.code || null,
//                 message: err.errors || 'An error occurred',
//             };
//             return { success: false, errorResponse };
//         } finally {
//             stopLoading(); // Stop loading setelah fetch selesai
//         }
//     };

//     return { deleteData, loading: useLoading().isLoading };
// };

export const useDeleteData = (url, stateType, queryString = '') => {
    const { dispatch } = useContext(AppContext);
    const { refetch } = useFetchData(`${url}${queryString}`, stateType);

    const deleteData = async (id) => {
        dispatch({ type: 'LOADING', stateType });
        try {
            const result = await deleteRequest(`${url}/${id}`);
            dispatch({ type: 'REMOVE_DATA', stateType, payload: id });
            refetch(); // Fetch ulang data setelah berhasil hapus
            return { success: true, data: result };
        } catch (err) {
            const errorResponse = {
                code: err.code || null,
                message: err.errors || 'An error occurred',
            };
            dispatch({ type: 'ERROR', stateType, payload: errorResponse })
            return { success: false, errorResponse };
        }
    };

    return { deleteData };
};

export const useAssignRole = (url, stateType) => {
    const { dispatch } = useContext(AppContext);

    const updateData = async (data) => {
        dispatch({ type: 'LOADING', stateType });
        try {
            const result = await postRequest(url, data);
            console.log('result', result);
            const updatedResult = {
                data: {
                    // id: result.data.id,
                    // display_name: result.data.display_name,
                    // name: result.data.name,
                    // permissions_count: result.data.permissions_count,
                    // users: result.data.users,
                    // users_count: result.data.users_count,
                    ...result.data,
                    permissions: result.data.permissions.map(item => item.name),
                }
            };
            dispatch({ type: 'UPDATE_DATA', stateType, payload: updatedResult });
            return { success: true, data: updatedResult };
        } catch (err) {
            const errorResponse = {
                code: err.code || null,
                message: err.errors || 'An error occurred',
            };
            dispatch({ type: 'ERROR', stateType });
            return { success: false, errorResponse };
        }
    };

    return { updateData };
};